import { AbstractControl, ValidatorFn } from '@angular/forms'

export const dateValidator: ValidatorFn = (control: AbstractControl): Record<string, any> | null => {
  const value: string = control.value
  return isDate(value) ? null : { date: true }
}

function isDate(object: string): boolean {
  return !/Invalid|NaN/.test(new Date(object).toString())
}
